import React from 'react';
import AppRoutes from '../../routes/routes';
import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';

export default function MarketingSubscribe() {
    return (
        <div id="subscribe" className="cta-section">
            <div className="cta-glow"></div>
            <div className="cta-grid"></div>
            <div className="cta-inner">
                <div className="hero-badge reveal mb-24-px">
                    <span className="hero-badge-dot"></span>
                    The Neurology Lounge on Substack
                </div>
                <h2 className="cta-h2 reveal">Clinical neurology<br /><em>insights & expert tips</em></h2>
                <p className="cta-sub reveal mb-32-px">Subscribe on Substack to get new checklist alerts and research updates in your inbox.</p>

                <a
                    href={AppRoutes.substackSubscribe}
                    className="btn btn-hero-primary substack-subscribe-btn reveal"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => PostHogService.capture(PostHogEvents.SUBSTACK_SUBSCRIBE_CLICKED, { source: 'homepage' })}
                >
                    Subscribe on Substack →
                </a>

                <p className="cta-note reveal mt-24-px">100% free · Unsubscribe anytime</p>
            </div>
        </div>
    );
}
